<script setup lang="ts">
const router = useRouter()

const items = ref([
  {
    label: 'Home',
    icon: 'home',
    route: '/dashboard',
  },
  {
    label: 'Published Interests',
    icon: 'inventory_2',
    route: '/published-interests',
  },
  {
    label: 'Negotiations',
    icon: 'handshake',
    route: '/negotiations',
  },
  {
    label: 'Chat',
    icon: 'chat',
    route: '/chat',
  },
])

const chatStore = useChatStore()
const { unreadMessageCount } = storeToRefs(chatStore)
const { isIos } = useDevice()
const { $pwa } = useNuxtApp()

const { isPageLoading } = storeToRefs(usePageStore())
const { setPageLoading } = usePageStore()
const onRouterLinkClick = async (e: MouseEvent, navigate: (e?: MouseEvent) => Promise<unknown>) => {
  if ((e.currentTarget as HTMLAnchorElement).href.indexOf(router.currentRoute.value.path) < 0) {
    setPageLoading(true)
  }
  router.isReady().then(() => navigate(e))
}
</script>

<template>
  <Menubar
    :model="items"
    :pt="{
      root: { class: 'justify-center bg-primary-500' },
      content: (args) => {
        const active = args.context.item.item.route === router.currentRoute.value.path ? 'bg-accent !text-black' : ''
        return { class: `text-white/75 hover:text-black dark:text-white/70 hover:bg-surface-100 transition-all duration-200  border-primary-500 hover:border-surface-100 ${active}` }
      },
      button: { class: 'hidden' },
      menu: { class: 'flex flex-row' },
      menuitem: { class: 'basis-1/4' }, // show only icons, but sm: show text as well
      action: { class: `pt-4 ${isIos && $pwa?.isPWAInstalled ? 'pb-6' : 'pb-3'} flex select-none cursor-pointer justify-center lg:basis-1/4 text-nowrap h-full` },
    }"
  >
    <template #item="{ item, props }">
      <router-link
        v-if="!isPageLoading"
        v-slot="{ href, navigate }"
        :to="item.route"
        custom
      >
        <a
          v-ripple
          class="h-full"
          :href="href"
          v-bind="props.action"
          @click="(e) => onRouterLinkClick(e, navigate)"
        >
          <span class="lg:basis-1/4 text-center relative">
            <Badge
              v-if="item.label === 'Chat' && unreadMessageCount > 0"
              :value="unreadMessageCount"
              :pt-options="{ mergeProps: true }"
              :pt:root="{ class: 'absolute -top-5 -right-3 lg:-right-0 !bg-alert ' }"
            />
            <i
              class="material-symbols-outlined !block text-3xl lg:text-2xl"
            >{{ item.icon }}</i>

            <span class="hidden lg:inline ">{{ item.label }}</span>
          </span>
        </a>
      </router-link>
      <div
        v-else
        class="h-full"
        v-bind="props.action"
      >
        <i
          class="pi pi-spin pi-spinner"
          style="font-size: 2rem"
        />
      </div>
    </template>
  </Menubar>
</template>

<style>
 /* html, body, #__nuxt, #default-layout {
  min-height: 100%;
} */
/*
              :pt="{ root: { class: 'block rounded-full w-4 h-4 bg-primary-300' } }"

body {
  overflow: hidden;
} */
</style>
